import { Component } from 'react'
import { createPortal } from 'react-dom'
import { MAP } from 'react-google-maps/lib/constants'

export default class MapControl extends Component {
  constructor(props) {
    super(props)

    this.map = props.context[MAP]
    this.controlDiv = document.createElement('div')
    this.divIndex = this.map.controls[props.position].length
    this.map.controls[props.position].push(this.controlDiv)
  }

  componentWillUnmount() {
    const { position } = this.props

    this.map.controls[position].removeAt(this.divIndex)
  }

  render() {
    const { children } = this.props

    return createPortal(children, this.controlDiv)
  }
}



// WEBPACK FOOTER //
// ./src/containers/mapView/components/Control.js